import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // CRITICAL: Use useRef to prevent double processing in StrictMode
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        try {
          const result = await exchangeSession(sessionId);
          // Navigate to dashboard with user data to skip auth check
          navigate('/', { replace: true, state: { user: result.user } });
        } catch (err) {
          console.error('Auth callback error:', err);
          navigate('/login', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-screen bg-vav-bg flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-vav-accent-cyan border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-vav-fg-muted">Giriş yapılıyor...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
